import React from 'react';
import { useGlobal } from '@rcg/ui-react';
import PropTypes from 'prop-types';
import { setPosition } from '../../commons';
import useStyles from './index.style';

const StateRoomBanner = ({ primaryBooking, notification }) => {
  const css = useStyles();
  const { renderContent } = useGlobal();
  const { stateroom, guests, id } = primaryBooking;
  const { deck, number, type, subType, position } = stateroom;
  const guarantee = number === 'GTY';
  const {
    infoBanner,
    infoBannerContent,
    infoBannerContentTitle,
    infoBannerContentGuests,
    infoBannerContentReservation,
  } = css;
  return (
    <div className={infoBanner}>
      {notification}
      <div className={infoBannerContent}>
        <div className={infoBannerContentTitle}>
          {guarantee
            ? renderContent('stateroomBookingAmendGuaranteeTitle', 'Guaranteed Stateroom')
            : subType}
        </div>
        <div className={infoBannerContentGuests}>
          {`${guests.length} ${renderContent('stateroomBookingAmendGuestsLabel', 'Guests')}`}
          {', '}
          {guarantee &&
            `${type.toLowerCase()} ${renderContent(
              'stateroomBookingAmendGuaranteeLabel',
              'Guarantee',
            ).toLowerCase()}`}
          {!guarantee && (
            <>
              {setPosition(renderContent(`formBookingAmend${position}`, position))}
              {', '}
              {`${renderContent('stateroomBookingAmendDeckLabel', 'Deck')}  ${
                guarantee ? '' : deck.code
              }`}
              {', '}
              {`${renderContent('stateroomBookingAmendRoomLabel', 'Room')} #${number}`}
            </>
          )}
        </div>
        <div className={infoBannerContentReservation}>
          {`${renderContent('stateroomBookingAmendReservationLabel', 'Reservation')} #${id}`}
        </div>
      </div>
    </div>
  );
};
StateRoomBanner.propTypes = {
  primaryBooking: PropTypes.shape({
    guests: PropTypes.string,
    id: PropTypes.string,
    stateroom: PropTypes.shape({
      deck: PropTypes.shape({
        code: PropTypes.string,
      }),
      number: PropTypes.string,
      type: PropTypes.string,
      subtype: PropTypes.string,
      position: PropTypes.string,
    }),
  }),
};

export default StateRoomBanner;
